// @ts-nocheck

// App
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { yieldCallback } from '@zillow/yield-callback';

// Actions
import AppActions from 'app/shared/flux/actions/AppActions';

// Hooks
import { useFilterChange } from 'app/shared/modules/MobileSRP/Header/FilterBar/hooks';

// Components
import AdvancedFilter from 'app/shared/modules/filter/AdvancedFilter';
import BedBathComboFilter from 'app/shared/modules/MobileSRP/Header/FilterModules/BedBathComboFilter';
import CommuteSelector from 'app/shared/modules/MobileSRP/Header/FilterModules/CommuteFilter';
import Modal from 'app/shared/modules/Modal';
import Pets from 'app/shared/modules/MobileSRP/Header/FilterModules/PetFilter';
import PriceFilter from 'app/shared/modules/MobileSRP/Header/FilterModules/PriceFilter';

// Misc / Utils
import './style.scss';
import appUtils from 'app/shared/utils/appUtils';
import { filterUtils_getChangedKeys } from 'app/shared/utils/filterUtils';
import {
  emitTrackHighPriceFilterEvent,
  emitTrackLowPriceFilterEvent,
} from 'app/shared/models/Clickstream/FilterClickstreamEvents';

const FilterModalController = () => {
  // Redux
  const dispatch = useDispatch();
  const showFilterModal = useSelector((state) => state.app.showFilterModal);
  const filter = useSelector((state) => state.filter);

  // Will store initial filter state to diff between current and previous state
  const initialFilterRef = useRef(null);

  // Hooks
  const { filterChange, shouldFetchFilteredResults, isFilterResetting } = useFilterChange();

  const handleClickstreamEvent = (changedKeys = []) => {
    if (changedKeys.includes('price.min')) {
      emitTrackLowPriceFilterEvent({
        triggerLocation: 'search_results',
        triggerObject: 'filter_panel',
      });
    }

    if (changedKeys.includes('price.max')) {
      emitTrackHighPriceFilterEvent({
        triggerLocation: 'search_results',
        triggerObject: 'filter_panel',
      });
    }

    // TODO: Record changes to other types of filters here as necessary
  };

  const handleCloseDropdown = yieldCallback(() => {
    appUtils.unlockVerticalScrolling();

    // If filter has changed, fetch new listings and close dropdown
    // Skip if filter is currently resetting to avoid duplicate API calls
    if (shouldFetchFilteredResults() && !isFilterResetting) {
      const changedKeys = filterUtils_getChangedKeys(initialFilterRef.current, filter);
      handleClickstreamEvent(changedKeys);

      filterChange({ ...filter }).then(() => dispatch(AppActions.setAppStoreBool('showFilterModal', false)));
    } else {
      // Else, just close dropdown
      dispatch(AppActions.setAppStoreBool('showFilterModal', false));
    }
  });

  useEffect(() => {
    if (initialFilterRef.current === null) {
      initialFilterRef.current = { ...filter };
    }
    // We don't want to add "filter" to the dependency array here
    // because we want to track the initial filter state.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let modalNode = null;
  const leftAlign = null;

  if (!showFilterModal) {
    return null;
  }

  if (showFilterModal === 'AllFiltersDropdown') {
    modalNode = <AdvancedFilter closeFilter={handleCloseDropdown} />;
  }

  if (showFilterModal === 'PriceSlider') {
    modalNode = (
      <div className="FilterModalController-dropdown-container" style={{ left: leftAlign }}>
        <PriceFilter showResetButton />
        <div className="FilterModalController-done-btn" onClick={handleCloseDropdown}>
          Done
        </div>
      </div>
    );
  }

  if (showFilterModal === 'BedsBathsSelector') {
    modalNode = (
      <div className="FilterModalController-dropdown-container" style={{ left: leftAlign }}>
        <BedBathComboFilter showResetButton triggerLocation="search_results" triggerObject="filter_panel" />
        <div className="FilterModalController-done-btn" onClick={handleCloseDropdown}>
          Done
        </div>
      </div>
    );
  }

  if (showFilterModal === 'CommuteSelector') {
    modalNode = (
      <div className="FilterModalController-dropdown-container" style={{ left: leftAlign }}>
        <CommuteSelector showResetButton />
        <div className="FilterModalController-done-btn" onClick={handleCloseDropdown}>
          Done
        </div>
      </div>
    );
  }

  if (showFilterModal === 'PetsSelector') {
    modalNode = (
      <div className="FilterModalController-dropdown-container" style={{ left: leftAlign }}>
        <Pets showResetButton />
        <div className="FilterModalController-done-btn" onClick={handleCloseDropdown}>
          Done
        </div>
      </div>
    );
  }

  return (
    <div className="FilterModalController">
      <Modal forceOverlay modalNavOffset onHidePopup={handleCloseDropdown}>
        {modalNode}
      </Modal>
    </div>
  );
};

export default FilterModalController;
